module.exports = __webpack_public_path__ + "static/media/ayudaBusqueda.31f70346.jpg";